import { Toast } from "../../views/common/components/toast"
import { isPC } from "../../utils/index"

export const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?`

export const appConfig = {
  appid: "",
  redirect_uri: window.location.href,
  response_type: "code",
  scope: "snsapi_base",
}

export function loadScript(url) {
  return new Promise((resolve, reject) => {
    // if (document.querySelector(`[src*="${url}"]`)) return resolve()

    try {
      const ele = document.createElement("script")
      ele.src = url
      document.body.appendChild(ele)

      ele.onload = resolve
      ele.onerror = reject
    } catch (error) {
      reject(error)
    }
  })
}

export function loadWxAgent() {
  if (window.wx && window.wx.agentConfig) return
  return loadScript(
    "https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js"
  )
}

export function loadWxEnv() {
  if (window.wx && window.wx.config) return
  return loadScript("https://res.wx.qq.com/open/js/jweixin-1.2.0.js")
}

export function requestUserCode(config) {
  const search = new URLSearchParams(
    Object.entries({ ...appConfig, ...config })
  ).toString()
  const url = loginUrl + search + "#wechat_redirect"
  window.location.href = url
}

let cacheCode = ''

export function getUserCode() {
  if (cacheCode) return cacheCode
  const search = new URLSearchParams(window.location.search)
  const code = search.get("code")
  if (code) {
    cacheCode = code
    search.delete('code')
    search.delete('state')
    // 避免刷新后 code 被复用
    window.history.replaceState(window.history.state, '', `${window.location.href.split('?')[0]}${search}${window.location.hash}`)
  }
  return code
}

export function configWxEnv(config) {
  return new Promise((resolve, reject) => {
    const newConfig = {
      beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: "", // 必填，企业微信的corpID
      timestamp: "", // 必填，生成签名的时间戳
      nonceStr: "", // 必填，生成签名的随机串
      signature: "", // 必填，签名，见 附录-JS-SDK使用权限签名算法
      jsApiList: ["agentConfig", "checkJsApi", "openDefaultBrowser"], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      ...config,
    }

    window.wx.config(newConfig)
    window.wx.ready(() => resolve(config))
    window.wx.error((e) => console.error(e))
  })
}

export function agentWxEnv(config) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const newConfig = {
        corpid: config.appId,
        agentid: config.agentId,
        timestamp: config.timestamp,
        nonceStr: "",
        signature: "",
        jsApiList: [
          "getCurExternalChat",
          "getCurExternalContact",
          "openEnterpriseChat",
          "openDefaultBrowser",
          "checkJsApi",
          'launchMiniprogram',
        ],
        success: () => resolve(config),
        fail: (e) => (alert("agentWxEnv:" + JSON.stringify(e)), reject(e)),
        ...config,
      }
      // alert(JSON.stringify(Object.keys(window.wx)))

      if (window.wx && window.wx.agentConfig) {
        window.wx.agentConfig(newConfig)
      } else {
        Toast("sdk加载失败,请重新进入应用")
        return reject("签名加密验证失败")
      }
    }, 10)
  })
}

export function getCurrentChatId() {
  return new Promise((resolve, reject) => {
    window.wx.invoke("getCurExternalChat", {}, function (res) {
      // alert('getCurExternalChat：' + JSON.stringify(res))
      if (res.err_msg == "getCurExternalChat:ok") return resolve(res.chatId)
      else {
        return reject("无法获取chat_id")
      }
    })
  })
}

export function getCurExternalContact() {
  return new Promise((resolve, reject) => {
    window.wx.invoke("getCurExternalContact", {}, function (res) {
      if (res.err_msg == "getCurExternalContact:ok") {
        resolve(res.userId) //返回当前外部联系人userId
      } else {
        // 错误处理
        reject("无法获取userid")
      }
    })
  })
}

export function CanUseWxApi(apiName) {
  return new Promise((resolve, reject) => {
    window.wx.checkJsApi({
      jsApiList: [apiName], // 需要检测的JS接口列表
      success: function (res) {
        if (res.checkResult[apiName]) return resolve()
        return reject()
      },
    })
  })
}

export function openEnterpriseChat(chatId) {
  return new Promise((resolve, reject) => {
    window.wx.openEnterpriseChat({ chatId, success: resolve, fail: reject })
  })
}

export function openDefaultBrowser(url) {
  return new Promise((resolve, reject) => {
    try {
      window.wx.invoke("openDefaultBrowser", { url }, (res) => {
        if (res.err_msg != "openDefaultBrowser:ok") return reject(res.err_msg)
        return resolve()
      })
    } catch (e) {
      return Promise.reject(e)
    }
  })
}

export function openUrl(url) {
  try {
    if (isPC()) return openDefaultBrowser(url)
    else window.location.href = url
  } catch (e) {
    return Promise.reject(e)
  }
}

export function getLinkFeedbackUrl() {
  if (isPC()) {
    if (window.location.href.includes("pftest.senguo")) {
      return "https://bbstest.senguo.me/feedbackadmin/#/"
    } else {
      return "https://bbs.senguo.cc/feedbackadmin/#/"
    }
  } else {
    if (window.location.href.includes("pftest.senguo")) {
      return "https://bbstest.senguo.me/m/#/feedback/edit"
    } else {
      return "https://bbs.senguo.cc/m/#/feedback/edit"
    }
  }
}

export function isInWxwork() {
    return /wxwork/i.test(navigator.userAgent)
}